var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('TabView',[_c('TabPanel',{attrs:{"header":"ข้อมูลประเภทร้านค้า"}},[_c('system-general')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }